"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7693],{

/***/ 63321:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ Glide; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var _glidejs_glide__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90400);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93859);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21483);





var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Glide = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)((_a, ref) => {
  var _b = _a, {
    className,
    children,
    onSlideChange,
    style,
    showControl = true,
    showBullet = false
  } = _b, glideOpts = __objRest(_b, [
    "className",
    "children",
    "onSlideChange",
    "style",
    "showControl",
    "showBullet"
  ]);
  const newRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const childRefs = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)([]);
  const chooseRef = ref || newRef;
  const opts = __spreadValues(__spreadValues({}, defaultGlideOptions), glideOpts);
  if (children.length === 1) {
    opts.autoplay = false;
    showBullet = false;
    showControl = false;
  }
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (typeof chooseRef === "function" || !chooseRef.current)
      return;
    const controller = new _glidejs_glide__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z(chooseRef.current, opts);
    let mounted;
    if (onSlideChange) {
      controller.on("move.after", () => {
        mounted && onSlideChange(mounted.index);
      });
    }
    (0,_teko_utils__WEBPACK_IMPORTED_MODULE_3__/* .scheduleTaskInIdleTime */ .D_)(() => {
      mounted = controller.mount();
      children.length === 1 && (mounted == null ? void 0 : mounted.disable());
      if (chooseRef.current) {
        chooseRef.current.glide = mounted;
      }
    }, 3e3);
    return () => mounted == null ? void 0 : mounted.destroy();
  }, []);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, {
    ref: chooseRef,
    className: `${className || ""} glide`,
    style
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "glide__track",
    "data-glide-el": "track"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "glide__slides"
  }, react__WEBPACK_IMPORTED_MODULE_0__.Children.map(children, (child, index) => {
    var _a2, _b2, _c;
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
      ref: (e) => childRefs.current[index] = e,
      key: child.key || index,
      className: "glide__slide",
      style: {
        height: "unset",
        marginRight: index < children.length - 1 ? ((_a2 = childRefs.current[index]) == null ? void 0 : _a2.style.marginRight) || 5 : 0,
        marginLeft: index > 0 ? ((_b2 = childRefs.current[index]) == null ? void 0 : _b2.style.marginLeft) || 5 : 0,
        width: ((_c = childRefs.current) == null ? void 0 : _c[0]) ? childRefs.current[0].style.width : `calc(100% / ${opts.perView})`
      }
    }, child);
  })), showControl && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    "data-glide-el": "controls",
    className: "glide__arrows"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "glide__arrow--override glide__arrow--left",
    "data-glide-dir": `${opts.perSwipe ? "|" : ""}<`
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "glide__arrow--override glide__arrow--right",
    "data-glide-dir": `${opts.perSwipe ? "|" : ""}>`
  })), showBullet && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "glide__bullets glide__bullets--override",
    "data-glide-el": "controls[nav]"
  }, react__WEBPACK_IMPORTED_MODULE_0__.Children.map(children, (_, index) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("button", {
    className: "glide__bullet",
    key: index,
    "data-glide-dir": `=${index}`
  })))));
});
Glide.displayName = "Glide";
const Wrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div`
  &:hover {
    .glide__arrow--override {
      visibility: visible;
    }
  }

  .glide__track {
    overflow: hidden;
    position: relative;
    height: 100%;
  }
  .glide__slides {
    height: 100%;
  }
  .glide__arrow--override {
    position: absolute;
    left: 0;
    top: 50%;
    z-index: 10;
    cursor: pointer;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    transform: translateY(-50%);
    background-color: rgba(168, 168, 168, 0.46);
    visibility: hidden;
  }

  .glide__arrow--left {
    right: auto;
    left: 0;
    border-top-right-radius: 100px;
    border-bottom-right-radius: 100px;

    &:after {
      mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjUgNUw4LjUgMTJMMTUuNSAxOSIgc3Ryb2tlPSIjODI4NjlFIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=');
      content: ' ';
      height: 30px;
      width: 30px;
      mask-size: contain;
      display: inline-block;
      background: #333;
    }
  }

  .glide__arrow--right {
    right: 0;
    left: auto;
    border-top-left-radius: 100px;
    border-bottom-left-radius: 100px;

    &:after {
      mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguNSAxOUwxNS41IDEyTDguNSA1IiBzdHJva2U9IiM4Mjg2OUUiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==');
      content: ' ';
      height: 30px;
      width: 30px;
      mask-size: contain;
      display: inline-block;
      background: #333;
    }
  }
`;
const defaultGlideOptions = {
  type: "slider",
  startAt: 0,
  perView: 2.3,
  perSwipe: "",
  focusAt: 0,
  gap: 10,
  autoplay: false,
  hoverpause: true,
  keyboard: true,
  bound: false,
  swipeThreshold: 80,
  dragThreshold: 120,
  perTouch: false,
  touchRatio: 0.5,
  touchAngle: 45,
  animationDuration: 400,
  rewind: false,
  rewindDuration: 800,
  animationTimingFunc: "cubic-bezier(0.165, 0.840, 0.440, 1.000)",
  direction: "ltr",
  peek: 0,
  breakpoints: {},
  throttle: 25
};




/***/ }),

/***/ 19298:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ MegaMenu; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71323);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21483);
/* harmony import */ var _MenuPanel_es_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74010);
/* harmony import */ var _TekoLink_TekoLink_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92651);
/* harmony import */ var _EnhancedImage_EnhancedImage_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34567);






var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const MegaMenu = ({
  type,
  align = "left",
  menuItems
}) => {
  const [activeMenu, setActiveMenu] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(void 0);
  const verticalMenuWidth = "12.375rem";
  const horizontalMenuHeight = "3rem";
  const megaMenuHeight = "28.5rem";
  if (!menuItems.length)
    return null;
  const hideMenuPanel = () => {
    setActiveMenu(void 0);
  };
  const renderVerticalMegaMenu = () => {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(MegaMenuWrapper, {
      onMouseLeave: hideMenuPanel
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(VerticalMegaMenu, {
      className: activeMenu ? "active" : "",
      width: verticalMenuWidth,
      height: megaMenuHeight
    }, menuItems.slice(0, 14).map((item, index) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_TekoLink_TekoLink_es_js__WEBPACK_IMPORTED_MODULE_1__/* .TekoLink */ .A, __spreadProps(__spreadValues({}, item.link), {
      key: index
    }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(VerticalMenuItem, {
      onMouseEnter: () => {
        setActiveMenu(item);
      }
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(VerticalMenuItemImageMegaMenuWrapper, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_EnhancedImage_EnhancedImage_es_js__WEBPACK_IMPORTED_MODULE_2__/* .EnhancedImage */ .N, {
      src: item.icon,
      height: "100%"
    })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Caption */ .YS, {
      level: 2,
      line: 1,
      style: { flex: 1 }
    }, item.name))))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(VerticalMenuPanel, {
      className: activeMenu ? "active" : "",
      type,
      verticalMenuWidth,
      menu: activeMenu,
      onClickMenuItem: hideMenuPanel
    }));
  };
  const renderHorizontalMegaMenu = () => {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(MegaMenuWrapper, {
      onMouseLeave: hideMenuPanel
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(HorizontalMegaMenu, {
      height: horizontalMenuHeight,
      align
    }, menuItems.slice(0, 14).map((item, index) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_TekoLink_TekoLink_es_js__WEBPACK_IMPORTED_MODULE_1__/* .TekoLink */ .A, __spreadProps(__spreadValues({}, item.link), {
      key: index
    }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(HorizontalMenuItem, {
      height: horizontalMenuHeight,
      onMouseEnter: () => {
        setActiveMenu(item);
      }
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Body */ .uT, {
      level: 2,
      line: 1,
      hoverColor: "primary500"
    }, item.name))))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(HorizontalMenuPanel, {
      type,
      className: activeMenu ? "active" : "",
      horizontalMenuHeight,
      menu: activeMenu,
      onClickMenuItem: hideMenuPanel
    }));
  };
  if (type === "vertical")
    return renderVerticalMegaMenu();
  return renderHorizontalMegaMenu();
};
const MegaMenuWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div */ .Z.div`
  position: relative;
`;
const VerticalMenuPanel = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_MenuPanel_es_js__WEBPACK_IMPORTED_MODULE_5__/* .MenuPanel */ .G)(({
  verticalMenuWidth,
  theme
}) => `
  position: absolute;
  top: 0;
  width: calc(75rem - ${verticalMenuWidth});
  left: ${verticalMenuWidth};
  min-height: 100%;
  z-index: 980;
  overflow: hidden;
  transition: all 0.2s;
  visibility: hidden;
  opacity: 0;
  border-radius: ${theme == null ? void 0 : theme.borderRadius.m};
  &.active {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    visibility: visible;
    opacity: 1;
  }
`);
const HorizontalMenuPanel = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_MenuPanel_es_js__WEBPACK_IMPORTED_MODULE_5__/* .MenuPanel */ .G)(({
  horizontalMenuHeight,
  theme
}) => `
  position: absolute;
  left: 0;
  right: 0;
  top: ${horizontalMenuHeight};
  z-index: 980;
  overflow: hidden;
  visibility: hidden;
  opacity: 0;
  transition: all 0.2s;
  border-bottom-right-radius: ${theme == null ? void 0 : theme.borderRadius.m};
  border-bottom-left-radius: ${theme == null ? void 0 : theme.borderRadius.m};
  &.active {
    visibility: visible;
    opacity: 1;
    filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.05));
  }
`);
const VerticalMegaMenu = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div */ .Z.div(({ theme, width, height }) => `
  border-radius: ${theme == null ? void 0 : theme.borderRadius.m};
  background-color: ${theme == null ? void 0 : theme.colors.white};
  position: relative;
  overflow: hidden;
  width: ${width};
  height: ${height};
  z-index: 980;
  &.active {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
`);
const HorizontalMegaMenu = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div */ .Z.div(({ theme, height, align }) => `
  height: ${height};
  background-color: ${theme == null ? void 0 : theme.colors.white};
  width: 100%;
  overflow: hidden;
  ${align === "right" ? `display: flex;
        justify-content: flex-end;` : align === "space-between" ? `display: flex;
        justify-content: space-between;` : ""}
`);
const VerticalMenuItem = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div */ .Z.div(({ theme }) => `
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: start;
  gap: ${theme == null ? void 0 : theme.spacing.s8};
  padding: 0 ${theme == null ? void 0 : theme.spacing.s8};
  border-radius: ${theme == null ? void 0 : theme.borderRadius.m};
  overflow: hidden;
  &:hover {
    background-color: ${theme == null ? void 0 : theme.colors.primary50};
    color: ${theme == null ? void 0 : theme.colors.primary500};
  }
`);
const HorizontalMenuItem = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div */ .Z.div(({ theme, height }) => `
  padding: 0 ${theme == null ? void 0 : theme.spacing.s12};
  height: ${height};
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  float: left;
  position: relative;
  transition: all 0.3s ease;
  color: ${theme == null ? void 0 : theme.colors.textPrimary};
  &::after {
    content: '';
    height: 2px;
    background-color: ${theme == null ? void 0 : theme.colors.primary500};
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    opacity: 0;
    transition: all 0.3s ease;
  }
  &:hover {
    color: ${theme == null ? void 0 : theme.colors.primary500};
    &::after {
      opacity: 1;
    }
  }
`);
const VerticalMenuItemImageMegaMenuWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div */ .Z.div`
  width: 22px;
  height: 22px;
`;




/***/ }),

/***/ 74010:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ MenuPanel; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71323);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21483);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28247);
/* harmony import */ var _helpers_megaMenu_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41753);
/* harmony import */ var _TekoLink_TekoLink_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92651);
/* harmony import */ var _EnhancedImage_EnhancedImage_es_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(34567);







var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const MenuPanel = ({
  menu,
  className,
  type,
  onClickMenuItem
}) => {
  var _a, _b, _c, _d;
  const bannerWidth = "14.625rem";
  if (!menu || !((_a = menu.banner) == null ? void 0 : _a.src) && !((_b = menu.children) == null ? void 0 : _b.length))
    return null;
  const bannerSrc = (_c = menu.banner) == null ? void 0 : _c.src;
  const getMenuColumns = () => {
    let totalCols = 6;
    if (type === "vertical")
      totalCols--;
    if (bannerSrc)
      totalCols--;
    return totalCols;
  };
  const newMenu = (0,_helpers_megaMenu_es_js__WEBPACK_IMPORTED_MODULE_1__/* .convertMegaMenu */ .R)(menu, getMenuColumns());
  const col = (item) => {
    return item.map((it, index) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(MenuLv2, {
      key: it.name + `-${index}`,
      onClick: onClickMenuItem
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_TekoLink_TekoLink_es_js__WEBPACK_IMPORTED_MODULE_2__/* .TekoLink */ .A, __spreadValues({}, it.link), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .SubTitle */ .DK, {
      level: 1,
      line: 1,
      color: "primary500",
      marginBottom: "s8"
    }, it.name)), it.children.map((subItem, index2) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_TekoLink_TekoLink_es_js__WEBPACK_IMPORTED_MODULE_2__/* .TekoLink */ .A, __spreadProps(__spreadValues({}, subItem.link), {
      key: index2
    }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Text, null, subItem.name)))));
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(MenuPanelWrapper, {
    className
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(MenuItemsWrapper, __spreadValues({}, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_4__/* .getTrackingData */ .O)({
    regionName: "megaMenuText",
    isTrackContent: true
  })), newMenu.map((menu2, index) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Column, {
    key: index
  }, col(menu2.column)))), bannerSrc && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_TekoLink_TekoLink_es_js__WEBPACK_IMPORTED_MODULE_2__/* .TekoLink */ .A, __spreadValues({}, (_d = menu.banner) == null ? void 0 : _d.link), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_EnhancedImage_EnhancedImage_es_js__WEBPACK_IMPORTED_MODULE_5__/* .EnhancedImage */ .N, {
    src: bannerSrc,
    width: bannerWidth,
    height: "100%",
    googleImageParams: {
      width: 400
    },
    tracking: (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_4__/* .getTrackingData */ .O)({
      regionName: "megaMenuBanner",
      isTrackContent: true
    })
  })));
};
const Text = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div */ .Z.div(({ theme }) => `
  color: ${theme == null ? void 0 : theme.colors.textPrimary};
  margin-bottom: 4px;
  &:hover {
    color: ${theme == null ? void 0 : theme.colors.primary500};
  }
`);
const MenuPanelWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div */ .Z.div(({ theme }) => `
  background-color: ${theme == null ? void 0 : theme.colors.white};
  display: flex;
`);
const MenuItemsWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div */ .Z.div(({ theme }) => `
  display: flex;
  flex: 1;
  padding: ${theme == null ? void 0 : theme.spacing.s12};
`);
const MenuLv2 = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div */ .Z.div`
  margin-bottom: 1.5rem;
`;
const Column = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div */ .Z.div`
  width: 25%;
  padding: 0 8px;
`;




/***/ }),

/***/ 41753:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ convertMegaMenu; }
/* harmony export */ });
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const convertMegaMenu = (menu, numberCol) => {
  if (numberCol < 1)
    return [];
  const newArr = menu.children.map((m) => {
    return {
      len: m.children.length + 1,
      column: [__spreadValues({}, m)]
    };
  });
  if (newArr.length <= numberCol)
    return newArr;
  newArr.sort((a, b) => b.len - a.len);
  const result = [...newArr.slice(0, numberCol)];
  let min;
  let k;
  for (let i = numberCol; i < newArr.length; i++) {
    min = result[0].len;
    k = 0;
    for (let j = 0; j < numberCol; j++) {
      if (min > result[j].len) {
        min = result[j].len;
        k = j;
      }
    }
    result[k] = {
      len: result[k].len + newArr[i].len,
      column: [...result[k].column, ...newArr[i].column]
    };
  }
  return result;
};




/***/ }),

/***/ 39559:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ BannerSlides; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61261);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91987);
/* harmony import */ var _teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34567);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21483);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(63321);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28247);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88813);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  .glide__bullets--override {\n    bottom: 7em;\n  }\n\n  .glide__bullet--active {\n    background-color: ",
        ";\n  }\n\n  .glide__slide a {\n    width: 100%;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






const serverless = (0,_helpers__WEBPACK_IMPORTED_MODULE_2__/* .isServerless */ .ep)();
const BannerSlides = (param)=>{
    let { banners , imageWidth =1920 , sliderRef , prioritized  } = param;
    if (!banners.length) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledGlide, {
        ref: sliderRef,
        perView: 1,
        autoplay: 3000,
        type: "carousel",
        showControl: false,
        showBullet: true,
        children: banners.map((banner, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SlideWrapper, _objectSpreadProps(_objectSpread({
                className: "glide__slide"
            }, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_3__/* .getTrackingData */ .O)({
                isTrackContent: true,
                regionName: "topSliderBannerHomepage",
                contentName: banner.campaignName,
                target: banner.targetPath,
                index
            })), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_4__/* .EnhancedImage */ .N, {
                    googleImageParams: {
                        width: imageWidth
                    },
                    link: {
                        href: serverless && banner.targetPath && banner.targetPath.startsWith(location.origin) ? banner.targetPath.replace(location.origin, "") : banner.targetPath
                    },
                    objectFit: "cover",
                    width: "100%",
                    height: 566,
                    src: banner.image,
                    thumbnail: banner.thumbnail,
                    alt: banner.campaignName,
                    lazy: index === 0 ? false : true,
                    fetchPriority: index === 0 ? prioritized ? "high" : "auto" : "low"
                })
            }), index))
    });
};
const StyledGlide = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* .Glide */ .A)(_templateObject(), (param)=>{
    let { theme  } = param;
    return theme.colors.primary;
});
const SlideWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div */ .Z.div(_templateObject1());


/***/ }),

/***/ 39950:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ useHomePage; },
/* harmony export */   "O": function() { return /* binding */ useMobileDefaultHomePage; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97441);
/* harmony import */ var _useDiscovery__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30468);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28247);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93859);
/* harmony import */ var _teko_discovery__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89172);






const trackDiffBlocks = (clientBlocks, serverBlocks)=>{
    // This statement is used to track block mismatches between client and server
    if ((clientBlocks === null || clientBlocks === void 0 ? void 0 : clientBlocks.length) && (serverBlocks === null || serverBlocks === void 0 ? void 0 : serverBlocks.length)) {
        const clientBlocksIdMap = new Set(clientBlocks.map((param)=>{
            let { id  } = param;
            return id;
        }));
        const serverBlocksIdMap = new Set(serverBlocks.map((param)=>{
            let { id  } = param;
            return id;
        }));
        const trackBlocks = ()=>{
            (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_1__/* .trackCustomEvent */ .I)("homeBlocksDiff", {
                label: JSON.stringify({
                    serverBlocks: Array.from(serverBlocksIdMap),
                    clientBlocks: Array.from(clientBlocksIdMap)
                })
            });
        };
        if (clientBlocksIdMap.size !== serverBlocksIdMap.size) {
            trackBlocks();
        } else {
            for (const id of serverBlocksIdMap){
                if (!clientBlocksIdMap.has(id)) {
                    trackBlocks();
                    break;
                }
            }
        }
    }
};
const useHomePage = (serverBlocks)=>{
    const { result: personalizedHomePage  } = (0,_useDiscovery__WEBPACK_IMPORTED_MODULE_2__/* .usePersonalizeBlocks */ .yz)({
        pageTypeEnum: _teko_discovery__WEBPACK_IMPORTED_MODULE_3__/* .PageTypeEnum.HOME */ .DZ.HOME
    });
    const blocks = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>{
        if (personalizedHomePage === null || personalizedHomePage === void 0 ? void 0 : personalizedHomePage.length) {
            return personalizedHomePage;
        }
        return serverBlocks;
    }, [
        personalizedHomePage
    ]);
    const slideBanners = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>{
        const banner = (0,_helpers__WEBPACK_IMPORTED_MODULE_4__/* .findBlockByType */ .yA)(_teko_discovery__WEBPACK_IMPORTED_MODULE_3__/* .BlockType.WIDE_THICK_BANNER */ .kH.WIDE_THICK_BANNER, blocks);
        if (banner) {
            return (banner === null || banner === void 0 ? void 0 : banner.cookedData) || [];
        }
        return [];
    }, [
        blocks
    ]);
    const topRightBanners = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>{
        const banner = (0,_helpers__WEBPACK_IMPORTED_MODULE_4__/* .findBlockByType */ .yA)(_teko_discovery__WEBPACK_IMPORTED_MODULE_3__/* .BlockType.VERTICAL_2_BANNER */ .kH.VERTICAL_2_BANNER, blocks);
        if (banner) {
            return (banner === null || banner === void 0 ? void 0 : banner.cookedData) || [];
        }
        return [];
    }, [
        blocks
    ]);
    const popupBanner = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>{
        return (0,_helpers__WEBPACK_IMPORTED_MODULE_4__/* .findBlockByType */ .yA)(_teko_discovery__WEBPACK_IMPORTED_MODULE_3__/* .BlockType.POPUP_BANNER */ .kH.POPUP_BANNER, blocks);
    }, [
        blocks
    ]);
    const horizontalFourBanners = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>{
        var ref;
        return ((ref = (0,_helpers__WEBPACK_IMPORTED_MODULE_4__/* .findBlockByType */ .yA)(_teko_discovery__WEBPACK_IMPORTED_MODULE_3__/* .BlockType.HORIZONTAL_4_BANNER */ .kH.HORIZONTAL_4_BANNER, blocks)) === null || ref === void 0 ? void 0 : ref.cookedData) || [];
    }, [
        blocks
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        function trackDiff(deadline) {
            if (deadline.timeRemaining() > 5 || deadline.didTimeout) {
                trackDiffBlocks(personalizedHomePage, serverBlocks);
            } else {
                (0,_teko_utils__WEBPACK_IMPORTED_MODULE_5__/* .requestIdleCallback */ .Kk)(trackDiff);
            }
        }
        (0,_teko_utils__WEBPACK_IMPORTED_MODULE_5__/* .requestIdleCallback */ .Kk)(trackDiff);
    }, [
        personalizedHomePage,
        serverBlocks
    ]);
    return {
        slideBanners,
        topRightBanners,
        blocks,
        popupBanner,
        horizontalFourBanners
    };
};
const useMobileDefaultHomePage = (serverBlocks)=>{
    const { result: personalizedHomePage , isLoading: loadingHomePage  } = (0,_useDiscovery__WEBPACK_IMPORTED_MODULE_2__/* .usePersonalizeBlocks */ .yz)({
        pageTypeEnum: _teko_discovery__WEBPACK_IMPORTED_MODULE_3__/* .PageTypeEnum.HOME */ .DZ.HOME
    });
    const blocks = (personalizedHomePage === null || personalizedHomePage === void 0 ? void 0 : personalizedHomePage.length) ? personalizedHomePage : serverBlocks;
    const loading = !serverBlocks && loadingHomePage;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        function trackDiff(deadline) {
            if (deadline.timeRemaining() > 5 || deadline.didTimeout) {
                trackDiffBlocks(personalizedHomePage, serverBlocks);
            } else {
                (0,_teko_utils__WEBPACK_IMPORTED_MODULE_5__/* .requestIdleCallback */ .Kk)(trackDiff);
            }
        }
        (0,_teko_utils__WEBPACK_IMPORTED_MODULE_5__/* .requestIdleCallback */ .Kk)(trackDiff);
    }, [
        personalizedHomePage,
        serverBlocks
    ]);
    return {
        blocks,
        loading
    };
};


/***/ }),

/***/ 82257:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "J": function() { return /* binding */ AboveTheFold; }
});

// UNUSED EXPORTS: renderMegaMenu

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61261);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-dae21f56e7/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(21483);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Grid/Row.es.js + 1 modules
var Row_es = __webpack_require__(49624);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Container/Container.es.js
var Container_es = __webpack_require__(63512);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-250bf57412/1/packages/ds-foundation/dist/components/Grid/Col.es.js
var Col_es = __webpack_require__(58519);
;// CONCATENATED MODULE: ./modules/home/desktop/components/Next.svg
/* harmony default export */ var Next = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggb3BhY2l0eT0iMC4zIiBkPSJNMCAyNEMwIDEwLjc0NTIgMTAuNzQ1MiAwIDI0IDBINDhWNDhIMjRDMTAuNzQ1MiA0OCAwIDM3LjI1NDggMCAyNFoiIGZpbGw9IiMxQjFEMjkiLz4KPHBhdGggZD0iTTIxLjUgMzBMMjcuNSAyNEwyMS41IDE4IiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=");
;// CONCATENATED MODULE: ./modules/home/desktop/components/Previous.svg
/* harmony default export */ var Previous = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggb3BhY2l0eT0iMC4zIiBkPSJNMCAwSDI0QzM3LjI1NDggMCA0OCAxMC43NDUyIDQ4IDI0QzQ4IDM3LjI1NDggMzcuMjU0OCA0OCAyNCA0OEgwVjBaIiBmaWxsPSIjMUIxRDI5Ii8+CjxwYXRoIGQ9Ik0yNi41IDE4TDIwLjUgMjRMMjYuNSAzMCIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K");
// EXTERNAL MODULE: ./components/desktop/organisms/BannerSlides.tsx
var BannerSlides = __webpack_require__(39559);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-93b366d9df/1/packages/teko-ecommerce/dist/components/MegaMenu/MegaMenu.es.js
var MegaMenu_es = __webpack_require__(19298);
// EXTERNAL MODULE: ../../packages/tracking/dist/helper.es.js
var helper_es = __webpack_require__(28247);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-254a7c064d/0/cache/next-npm-12.3.1-f509d21386-ac78592379.zip/node_modules/next/dynamic.js
var dynamic = __webpack_require__(85470);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./modules/home/desktop/components/AboveTheFold.tsx
/* eslint-disable @typescript-eslint/ban-ts-comment */ function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  position: relative;\n  content-visibility: auto;\n  margin-bottom: 24px;\n  .swiper-pagination {\n    bottom: 6rem !important;\n  }\n  min-height: 600px;\n  @media screen and (max-width: ",
        "px) {\n    height: auto;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  z-index: 0;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  margin-top: -72px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}









const EnhancedImage = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(1579), __webpack_require__.e(6054), __webpack_require__.e(1633), __webpack_require__.e(6329), __webpack_require__.e(5125), __webpack_require__.e(8863), __webpack_require__.e(7631), __webpack_require__.e(8106), __webpack_require__.e(656), __webpack_require__.e(8251)]).then(__webpack_require__.bind(__webpack_require__, 40656)).then((mod)=>mod.EnhancedImage), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(40656)
            ]
    }
});
const FeaturedBanners = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(1579), __webpack_require__.e(6054), __webpack_require__.e(1633), __webpack_require__.e(6329), __webpack_require__.e(5125), __webpack_require__.e(8863), __webpack_require__.e(7631), __webpack_require__.e(8106), __webpack_require__.e(656), __webpack_require__.e(8251)]).then(__webpack_require__.bind(__webpack_require__, 40656)).then((mod)=>mod.FeaturedBanners), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(40656)
            ]
    }
});
const sliderHeight = 566;
const maxWidth = 767;
const Wrapper = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject(), maxWidth);
Wrapper.displayName = "AboveTheFold";
const StyledBannerSlides = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject1());
const FourBannerWrapper = (0,emotion_styled_browser_esm/* default */.Z)(Row_es/* Row */.X)(_templateObject2());
const NavBtnWrapper = emotion_styled_browser_esm/* default.img */.Z.img((param)=>{
    let { show , left , right  } = param;
    return "\n  opacity: ".concat(show ? "1" : "0", ";\n  z-index: 549;\n  cursor: pointer;\n  transition: 0.1s;\n  position: absolute;\n  top: 39.5%;\n  ").concat(left ? "left: ".concat(left, ";") : "", "\n  ").concat(right ? "right: ".concat(right, ";") : "", "\n");
});
const RightBannerWrapper = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject3());
const renderMegaMenu = (menuItems)=>{
    if (!(menuItems === null || menuItems === void 0 ? void 0 : menuItems.length)) return;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenu_es/* MegaMenu */.V, {
        menuItems: menuItems,
        type: "vertical"
    });
};
const AboveTheFold = (param)=>{
    let { menuItems , slideBanners =[] , topRightBanners =[] , horizontalFourBanners =[]  } = param;
    const sliderRef = (0,react.useRef)(null);
    const { 0: showNavBtns , 1: setShowNavBtns  } = (0,react.useState)(false);
    if (!menuItems.length && !slideBanners.length && !topRightBanners.length) return null;
    const isOnlySlideBanner = !menuItems.length && !topRightBanners.length;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container_es/* Container */.W, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row_es/* Row */.X, {
                    justify: "space-around",
                    style: {
                        height: "".concat(sliderHeight, "px")
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col_es/* Col */.JX, {
                            span: 2,
                            paddingTop: "s16",
                            children: [
                                renderMegaMenu(menuItems),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavBtnWrapper, {
                                    onMouseEnter: ()=>setShowNavBtns(true),
                                    show: showNavBtns,
                                    right: !isOnlySlideBanner && "-46px",
                                    left: isOnlySlideBanner && "0",
                                    onClick: ()=>{
                                        if (sliderRef.current) {
                                            sliderRef.current.glide.go("<");
                                        }
                                    },
                                    src: Previous,
                                    alt: ""
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                flex: 1
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBannerSlides, {
                                onMouseEnter: ()=>setShowNavBtns(true),
                                onMouseLeave: ()=>setShowNavBtns(false),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerSlides/* BannerSlides */.j, {
                                    imageWidth: 1920,
                                    banners: slideBanners,
                                    sliderRef: sliderRef,
                                    prioritized: true
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col_es/* Col */.JX, {
                            span: 2,
                            paddingTop: "s16",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavBtnWrapper, {
                                    onMouseEnter: ()=>setShowNavBtns(true),
                                    show: showNavBtns,
                                    onClick: ()=>{
                                        if (sliderRef.current) {
                                            sliderRef.current.glide.go(">");
                                        }
                                    },
                                    left: !isOnlySlideBanner && "-48px",
                                    right: isOnlySlideBanner && "0",
                                    src: Next,
                                    alt: ""
                                }),
                                topRightBanners.length !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(RightBannerWrapper, {
                                    children: topRightBanners.map((banner, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(EnhancedImage, {
                                            link: {
                                                href: banner.targetPath
                                            },
                                            tracking: (0,helper_es/* getTrackingData */.O)({
                                                isTrackContent: true,
                                                regionName: "topRightBannerHomepage",
                                                contentName: banner.campaignName,
                                                index: index,
                                                target: banner.targetPath
                                            }),
                                            src: banner.image,
                                            borderRadius: 8,
                                            height: 220,
                                            objectFit: "cover",
                                            googleImageParams: {
                                                width: 300
                                            },
                                            hover: "zoom",
                                            alt: banner.campaignName || banner.description || "",
                                            lazy: false,
                                            fetchPriority: "high"
                                        }, index))
                                })
                            ]
                        })
                    ]
                }),
                !!horizontalFourBanners.length && /*#__PURE__*/ (0,jsx_runtime.jsx)(FourBannerWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col_es/* Col */.JX, {
                        span: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedBanners, {
                            prioritized: true,
                            regionName: "bottomBanner",
                            banners: horizontalFourBanners.map((banner)=>{
                                return {
                                    src: banner.image,
                                    link: {
                                        href: banner.targetPath
                                    },
                                    name: banner.campaignName,
                                    lazy: false
                                };
                            })
                        })
                    })
                })
            ]
        })
    });
};


/***/ })

}]);